module.exports = __webpack_public_path__ + "img/pen-size-3.8143cef2.svg";